<div class="modal-header bg-secondary d-flex justify-content-between">
    <div class="modal-title text-white h5">
        {{ title }}
    </div>

    <button *ngIf="showCloseButton"
        type="button"
        class="close btn text-white"
        data-dismiss="modal"
        aria-label="Close"
        (click)="closeDialog()">
        <span aria-hidden="true">
            &times;
        </span>
    </button>
</div>
